/** Classes partagées pour le contenu scrollable des pages outils */
export const toolPageClass = "tool-page w-full min-w-0 max-w-full";

export const toolPagePaddingClass = "px-3 sm:px-4 lg:px-6 py-4 sm:py-6 lg:py-8";
